import { useState } from 'react'
import { UpcomingPayroll, UploadPayrollFileRowsModel } from '../../../../redux/types'
import usePayrollActions from '../../../../hooks/usePayrollActions'

/**
 * Hook for managing the create payroll file rows modal
 */
const useCreatePayrollFileRowsModal = (upcomingPayroll: UpcomingPayroll) => {
  const [visible, setVisible] = useState<boolean>(false)
  const { uploadPayrollFileRows, uploadOffCyclePayrollFileRows } = usePayrollActions()

  const handleCreate = (model: UploadPayrollFileRowsModel) => {
    const externalId = new Date().getTime().toString()
    if (upcomingPayroll.offCycle) {
      uploadOffCyclePayrollFileRows(externalId, upcomingPayroll.paymentDate, model)
    } else {
      uploadPayrollFileRows(externalId, upcomingPayroll.paymentDate, model)
    }
    setVisible(false)
  }

  return {
    visible,
    show: () => setVisible(true),
    hide: () => setVisible(false),
    handleCreate
  }
}

export default useCreatePayrollFileRowsModal 